import { combineReducers } from 'redux';
import authReducer from './authReducer';
import evidencesReducer from './evidencesReducer';
import peiReducer from './peiReducer'
import academicReducer from './academicReducer';
import evaluationReducer from './evaluationReducer';
import improvementPlanReducer from './improvementPlanReducer';
import overviewReducer from './overviewReducer';
import processReducer from './processReducer';
import matrixReducer from './matrixReducer';

export default combineReducers({
    auth: authReducer,
    evidence:evidencesReducer,
    pei:peiReducer,
    academic: academicReducer,
    evaluation: evaluationReducer,
    improvementPlan: improvementPlanReducer,
    overview: overviewReducer,
    process: processReducer,
    matrix: matrixReducer,
});